import React, { useMemo } from "react";
import { ArrowLeftOutlined, ArrowRightOutlined, CheckCircleFilled } from "@ant-design/icons";
import { Button, Col, Radio, Row } from "antd";
import { getGuidFirst8 } from "@/utils/utils";

const ETAInputNavBar = props => {
  const {
    shipmentsList,
    currentShipmentData,
    currentShipmentETAInputIndex,
    decrementCurrentShipmentETAInputIndex,
    incrementCurrentShipmentETAInputIndex,
    setCurrentShipmentETAInputIndex,
  } = props;

  const nextIndexToValidate = useMemo(() => {
    const nextUnvalidatedIndex = shipmentsList.findIndex(s => !s.etasValidated);
    return nextUnvalidatedIndex ?? -1;
  }, [currentShipmentETAInputIndex]);

  return (
    <Row
      justify="space-between"
      style={{
        marginBottom: 32,
        border: "1px solid #d9d9d9",
        backgroundColor: "rgb(252, 252, 252)",
        borderRadius: 20,
      }}
    >
      <Col style={{ marginRight: "2%" }}>
        <Button
          onClick={decrementCurrentShipmentETAInputIndex}
          disabled={currentShipmentETAInputIndex === 0}
          icon={<ArrowLeftOutlined />}
          type="primary"
        />
      </Col>
      <Col>
        <Radio.Group
          buttonStyle="solid"
          value={currentShipmentData.id}
          onChange={e => {
            const newSelectedShipmentId = e.target.value;
            const indexOfSelectedShipment = shipmentsList.findIndex(s => s.id === newSelectedShipmentId);

            setCurrentShipmentETAInputIndex(indexOfSelectedShipment);
          }}
        >
          {shipmentsList.map(({ id, etasValidated }, i) => {
            return (
              <Radio.Button key={id} value={id} disabled={!etasValidated && nextIndexToValidate !== i}>
                {getGuidFirst8(id)}
                {etasValidated && <CheckCircleFilled style={{ color: "#52c41a", marginLeft: 5 }} />}
              </Radio.Button>
            );
          })}
        </Radio.Group>
      </Col>

      <Col style={{ marginLeft: "2%" }}>
        <Button
          onClick={incrementCurrentShipmentETAInputIndex}
          disabled={currentShipmentETAInputIndex + 1 === shipmentsList.length || !currentShipmentData.etasValidated}
          icon={<ArrowRightOutlined />}
          type="primary"
        />
      </Col>
    </Row>
  );
};

export default ETAInputNavBar;
